import { render, staticRenderFns } from "./DateQuestion.vue?vue&type=template&id=30e4d4c6&scoped=true&"
import script from "./DateQuestion.vue?vue&type=script&lang=ts&"
export * from "./DateQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e4d4c6",
  null
  
)

export default component.exports